/**
 * A module representing dialog-manager.
 * @module dialog-manager
 * @exports Dialog
 * @see Dialog
 * @requires module:dialog
 * @requires module:modal
 * @requires module:feedback
 * @example
 * var Dialog = require('dialog-manager');
 */
define('dialog-manager',['dialog', 'pubsub'], function(Dialog, PubSub) {
    'use strict';

    var manager;

    /**
     * @constructor
     * @alias Dialogs
     * @param {Object}  options

     * @param {Element} [options.dialog = '#js-dialog' container] - dialog container
     * @param {String}  [options.mainClass = 'dialog'] - Container CSS class
     * @param {Boolean} [options.showClose = false] - Show close icon
     * @param {Boolean} [options.escapeClose = false] - Close dialog on escape key press
     * @param {Boolean} [options.enterClose = false] - Close dialog on enter key press
     * @param {String}  [options.label = ''] - Label content
     * @param {String}  [options.content = ''] - Main content
     * @param {String}  [options.footnote = ''] - Footer content
     */
    var Manager = function(options)  {
        options = options || {};

        this.dialog = null;

        this.dialogs = options.dialogs || [];
    };

    Manager.prototype.open = function(options) {
        options = options || {};

        switch(options.type) {
            case 'dialog':
                break;
            case 'feedback':
                options.type = 'feedback';
                options.dialog = options.dialog || document.getElementById('js-feedback');
                options.mainClass = options.mainClass || 'feedback';
                break;
            default:
                options.type = 'modal';
                options.dialog = options.dialog || document.getElementById('js-modal');
                options.mainClass = options.mainClass || 'modal';
                break;
        }

        this.dialog = new Dialog(options);

        this.dialogs.push(this.dialog);

        this.dialog.open();

        PubSub.publish('dialog-open', {
            dialog: this
        });

        return this.dialog;
    };

    Manager.prototype.close = function(options) {
        options = options || {};

        var type = Array.isArray(options.type) ? options.type : (typeof options.type === 'string') ? [options.type] : [];

        if (!this.dialogs.length) {
            return;
        }

        this.dialogs = this.dialogs.filter(function(dialog) {

            if (type.indexOf(dialog.type) !== -1 && !dialog.clone) {
                dialog.close();
                return false;
            }

            return true;
        });
    };

    return function(options) {

        if (!manager) {
            manager = new Manager(options);
        }

        return manager;
    };
});

